import * as t from "io-ts";
import { UUID as uuidCodec } from "io-ts-types/UUID";

import {
  donationFlowCustomizationDataCodec,
  donationFlowCustomizationResponseCodec,
} from "../codecs/donationFlowCustomization";
import { HttpMethod } from "../helpers/http";

import { makeRouteSpec } from ".";

/**
 * GET /nonprofit/:nonprofitId/donation-flow-customization
 * Returns the newest active DonationFlowCustomization matching the parameters
 */
export const getDonationFlowCustomizationRouteSpec = makeRouteSpec({
  path: "/nonprofit/:nonprofitId/donation-flow-customization",
  method: HttpMethod.GET,
  authenticated: false,
  tokensCodec: t.type({
    nonprofitId: uuidCodec,
  }),
  paramsCodec: t.partial({
    fundraiserId: uuidCodec,
    code: t.string,
  }),

  bodyCodec: t.type({}),
  responseBodyCodec: t.union([donationFlowCustomizationResponseCodec, t.null]),
  publicRoute: {
    publicCacheLengthMinutes: 1,
  },
});

/**
 * POST /nonprofit/:nonprofitId/donation-flow-customization
 * Creates a new DonationFlowCustomization
 * If not for a donate link/button, deactivates old ones per (nonprofit id, fundraiser id)
 */
export const postDonationFlowCustomizationRouteSpec = makeRouteSpec({
  path: "/nonprofit/:nonprofitId/donation-flow-customization",
  method: HttpMethod.POST,
  authenticated: true,
  tokensCodec: t.type({
    nonprofitId: uuidCodec,
  }),
  paramsCodec: t.type({}),
  bodyCodec: t.intersection([
    t.type({
      donateButton: t.boolean,
      active: t.boolean,
      customization: donationFlowCustomizationDataCodec,
    }),
    t.partial({
      fundraiserId: t.union([uuidCodec, t.null]),
    }),
  ]),
  responseBodyCodec: donationFlowCustomizationResponseCodec,
});

/**
 * PATCH /donation-flow-customization/:id
 * Updates an existing DonationFlowCustomization
 */
export const patchDonationFlowCustomizationRouteSpec = makeRouteSpec({
  path: "/donation-flow-customization/:id",
  method: HttpMethod.PATCH,
  authenticated: true,
  tokensCodec: t.type({ id: uuidCodec }),
  paramsCodec: t.type({}),
  bodyCodec: t.partial({
    active: t.boolean,
    code: t.union([t.string, t.null]),
    customization: donationFlowCustomizationDataCodec,
  }),
  responseBodyCodec: donationFlowCustomizationResponseCodec,
});

/**
 * POST /nonprofit/:nonprofitId/donation-flow-customization/reset
 * Deactivates all DonationFlowCustomizations for a (nonprofitId, fundraiserId) combination
 */
export const resetDonationFlowCustomizationRouteSpec = makeRouteSpec({
  path: "/nonprofit/:nonprofitId/donation-flow-customization/reset",
  method: HttpMethod.POST,
  authenticated: true,
  tokensCodec: t.type({ nonprofitId: uuidCodec }),
  paramsCodec: t.type({}),
  bodyCodec: t.partial({
    fundraiserId: t.union([uuidCodec, t.null]),
  }),

  responseBodyCodec: t.type({
    deactivatedCount: t.number,
  }),
});
